import React, {Component} from 'react';

import { validationInput } from '../../shared/ValidationUtils'
import DynamicInput from '../../UI/DynamicInput/DynamicInput';
import { identifiers } from '../../shared/Constants';


export class SdkPortalForm extends Component {
    
    state = {
        sdkPortalForm: {
            firstName: {
                componentType: "tier1",
                validationRules: [
                    {
                        name: "specialchar",
                        value: ['<','"','+',':',';','=','\\','*','&','(',')','#', ',']
                    },
                    {
                        name: "maxLength",
                        value: 40
                    },
                    {
                        name: "minLength",
                        value: 1
                    }
                ],
                inputType: "text",
                id: "firstName",
                idProcessEngine: "firstName",
                label: "First Name",
                value:"",
                isFixed: true,
                properties: {
                    placeholder: "first name",
                    maxLength: 41
                }
            },
            lastName: {
                componentType: "tier1",
                validationRules: [
                    {
                        name: "specialchar",
                        value: ['<','"','+',':',';','=','\\','*','&','(',')','#', ',']
                    },
                    {
                        name: "maxLength",
                        value: 40
                    },
                    {
                        name: "minLength",
                        value: 1
                    }
                ],
                inputType: "text",
                id: "lastName",
                idProcessEngine: "lastName",
                label: "Last Name",
                value:"",
                isFixed: true,
                properties: {
                    placeholder: "last name",
                    maxLength: 41
                }
            },
            dob: {
                componentType: "dob",
                validationRules: [
                    {
                        name: "restrictFuture"
                    }
                ],
                inputType: "date",
                id: "dob",
                idProcessEngine: "dob",
                label: "DOB",
                value: "",
                isFixed: true,
                properties: {
                    placeholder: "mm/dd/yyyy",
                    min: "1900-01-01"
                }
            }
        },
        populatedSdkForm: null
    }

    componentDidMount () {
        let populatedSdkForm = this.buildSdkForm();

        let {validatedSdkForm,isFormValid} = this.applyValidation(populatedSdkForm);
        
        this.setState({...this.state,populatedSdkForm:validatedSdkForm});
        this.props.updateFormValidityState(isFormValid);        

    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedPortal.portalShortName !== this.props.selectedPortal.portalShortName) {
            let populatedSdkForm = this.buildSdkForm();

            let {validatedSdkForm,isFormValid} = this.applyValidation(populatedSdkForm);
            
            this.setState({...this.state,populatedSdkForm:validatedSdkForm, selected: undefined});
            this.props.updateFormValidityState(isFormValid);   
        }
    }

    buildSdkForm = (radioButtonState) =>{

        let sdkForm = {
            ...this.state.sdkPortalForm
        }

        //Accomodate dynamic fileds from portalConfig data
        let fields = null;
        /*Passing radioButtonState from radioButtonChange event which is basically selected object
        if radioButton state is provided then UI segment should work according to that because previous state of radio button is
        persisted in this.state.selected
        */
        if(radioButtonState){
            fields = this.props.uiIdentificationTypes[radioButtonState.value].elements;
        }else{
            if(this.state.selected && this.props.uiIdentificationTypes[this.state.selected.value]){
                fields = this.props.uiIdentificationTypes[this.state.selected.value].elements;
            }else{
                fields = this.props.uiIdentificationTypes[0].elements
            }
        }
        for(let key in fields) {
            /*
            Condition was written to reutilize same created object from state. Added condition to match id and label value because
            some times id could be same but there display label value could be different. e.g : OptumLabs loop and Allsavers both Tier 1 component
            is having same id but different value.
            */
            sdkForm[fields[key].id]= (this.state.populatedSdkForm && this.state.populatedSdkForm[fields[key].id] && this.state.populatedSdkForm[fields[key].label] )
            ? this.state.populatedSdkForm[fields[key].id] : fields[key];
        }
        //Populate data into form
        let populatedSdkForm = this.setEligibilityData(sdkForm);
        return populatedSdkForm;
    }


    setEligibilityData =(form) =>{
        delete form["UUID"];

        let elems = [{formName: "firstName", fieldName: "mdmFirstNm"}, {formName: "lastName", fieldName: "mdmLastNm"}, { formName: "dob", fieldName: "mdmDob"}];
        let optionalElems = [{formName: "memberId"}, {formName: "groupNumber"}];

        if(this.props.memberInfo && this.props.selectedPortal) {
            for(let key in elems) {
                let formElement = {
                    ...form[elems[key].formName]
                }
                formElement["value"] = this.props.memberInfo[elems[key].fieldName];
                form = {...form, [elems[key].formName]: formElement};
                
            }
            for(let key in optionalElems) {
                if (form[optionalElems[key].formName]) {
                    let formElement = {
                        ...form[optionalElems[key].formName]
                    }
                    formElement["value"] = "";
                    form = {...form, [optionalElems[key].formName]: formElement};
                }
            }
        }      
        return form;
    }

    resetForm = () => {
        let clearForm = {...this.state.populatedSdkForm};
        for(let formElement in clearForm){
                clearForm[formElement].value = '';
                clearForm[formElement].touched = false;
                clearForm[formElement].isValid = false;
        }
        this.setState({
            ...this.state,
            populatedSdkForm: clearForm
        });
        this.props.updateFormValidityState(false);
    }

    getFormData = (formData) => {
        for( let key in this.state.populatedSdkForm) {
            const dataField = this.state.populatedSdkForm[key];           
            formData[dataField.idProcessEngine]= this.state.populatedSdkForm[key].value;
        }
        return formData;
    }

    render() {
        if(!this.props.isSDKPortal){
            return null;
        }
        let fixedFormComponents = null;
        let radioButtonComponents = null;
        let optionalFormComponent = null;

        if(this.state.populatedSdkForm){

        /*FirstName, LastName and DOB which are fixed*/
         fixedFormComponents = (
            <React.Fragment>{Object.entries(this.state.populatedSdkForm).map((formElement, index) => {
                if(formElement[1].isFixed){
                    return (
                        <DynamicInput
                            key={formElement[1].id}
                            uiIdentificationTypes={formElement[1]}
                            handleOnChange={(event) => this.handleInput(event, formElement[1].id, index)}
                            styleClasses="Input"
                            value={formElement[1].value}
                        />
                    )}
                    return undefined;
                })}
            </React.Fragment>);


        /* Radio button component, basically uiIdentification types each element inside array*/
        radioButtonComponents = this.props.uiIdentificationTypes.length === 1 ? null :
            this.props.uiIdentificationTypes.map((element, index) => {             
                    return (
                        <React.Fragment key={element.id}>
                            <input
                                type="radio"
                                id={element.id}
                                key={element.id}
                                value={index}
                                checked={this.state.selected ? undefined : 0===index}
                                onChange={this.onRadioButtonChange}
                                disabled={false}
                                name="radioBtnGroup"
                                style={{width:"4%"}}
                                />  
                                <label htmlFor={element.id} style={{margin:"6px 0"}}>{element.label}</label>
                        </React.Fragment>)
                       
                }
            );

    
        /*Tier 1 and Tier 2 component based on portal config*/
    
        optionalFormComponent = (
            <React.Fragment>
                {Object.entries(this.state.populatedSdkForm).map((formElement, index) => {
                    if(!formElement[1].isFixed){
                        if(formElement[1].id === 'ssn') {
                            formElement = this.handleSsnComponent(formElement);
                        }
                    return (
                        <DynamicInput
                            key={formElement[1].id}
                            uiIdentificationTypes={formElement[1]}
                            handleOnChange={(event) => this.handleInput(event, formElement[1].id, index)}
                            styleClasses="Input"
                            value={formElement[1].value}
                        />
                    );
                    }
                    return undefined;
                })
                }
            </React.Fragment>
            );
  
            }
        return (
            <div>
                {fixedFormComponents}
                <fieldset style={{display: "block", width: "100%"}}>
                {radioButtonComponents}
                </fieldset>
                {optionalFormComponent}
            </div>
        );
    }

    onRadioButtonChange = e => {
        const { id, value } = e.target;
        let selected = {id,value};
        //Because selection changed we need to re populate the UI according to radioButton selection
       let populatedSdkForm = this.buildSdkForm(selected);

       let {validatedSdkForm,isFormValid} = this.applyValidation(populatedSdkForm);

        this.setState({
            ...this.state,
            selected,
            populatedSdkForm:validatedSdkForm
        });
        this.props.updateFormValidityState(isFormValid);
        
    };

    handleInput = (e,inputIdentifier, fieldIndex) => {
        const { value } = e.target;

        let updatedElement = {...this.state.populatedSdkForm[inputIdentifier],value:value};

        //To update the edits on the UI
        const validity = validationInput(updatedElement);
        updatedElement = {...updatedElement,isValid: validity.isValid, touched: true};
        let updatedForm = {...this.state.populatedSdkForm};
        updatedForm[inputIdentifier] = updatedElement; 

        // Checking if all the feilds of form are valid
        let isFormValid = true;
        for (const key in updatedForm) {
            const element = updatedForm[key];
            isFormValid = isFormValid && element.isValid;
        }
        this.setState({...this.state,populatedSdkForm:updatedForm});
        this.props.updateFormValidityState(isFormValid)

        if(validity.isValid) {
            this.props.displayMessageHandler(null);
        } else if (validity.message) {
            this.props.displayMessageHandler({type: "Error", info: {message: validity.message}});
        }

    };

    handleSsnComponent = (formElement) => {
        //Hardcoded to 9 digit as from portal config we get as 6
        formElement[1].mask = "999999999";

        const validationRulesArray = formElement[1].validationRules;

        for (let index in validationRulesArray) {
            const validationRule = validationRulesArray[index];
            if (validationRule.name === 'minLength') {
                formElement[1].validationRules[index].value = 9;
            }
            
        }

        return formElement;
    }

    applyValidation = (populatedSdkForm) => {
        let isFormValid = true;
        let validatedSdkForm = {};
        for (const key in populatedSdkForm) {
            const element = populatedSdkForm[key];
            let validity = validationInput(element);
            isFormValid = validity && validity.isValid;
            let touched = !!populatedSdkForm[key].value;
            validatedSdkForm[key] = {
                                        ...element,
                                        isValid: validity.isValid,
                                        touched: touched
                                    };
        }
        return {validatedSdkForm,isFormValid};
    }

}


export default SdkPortalForm;